import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  modalTitle: {
    fontSize: '20px !important'
  }
}))
